export enum TabState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export type TabValue = string | number
